import {
  Box,
  Container,
  FileInput,
  Group,
  Title,
  Button,
  TextInput,
  Stack,
  Textarea,
  Loader,
  ThemeIcon,
} from "@mantine/core";
import Navigation from "../Navigation";
import { useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import { applyJob } from "../../utils/api-communication/RestApiCli";
import { IconCheck } from "@tabler/icons-react";
import { useSearchParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";

export default function JobPage(props) {
  const [jobId, setJobId] = useState(null);
  const [value, setValue] = useState<File | null>(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [fileContent, setFileContent] = useState("");
  const [jobNotFound, setJobNotFound] = useState(false);

  useEffect(() => {
    if (!jobId) return;
    fetch(`/jobs/${jobId}.md`)
      .then((response) => {
        if (!response.ok) {
          setFileContent("Job description not found.");
          setJobNotFound(true);
          return;
        }
        response.text().then((text) => {
          if (text.trim().startsWith("<!DOCTYPE html") || text.trim().startsWith("<html")) {
            setFileContent("Job description not found.");
            setJobNotFound(true);
          } else {
            setFileContent(text);
            setJobNotFound(false);
          }
        });
      })
      .catch((error) => {
        console.error("Error loading file:", error);
        setFileContent("Job description not found.");
        setJobNotFound(true);
      });
  }, [jobId]);

  useEffect(() => {
    const uuid = searchParams.get("id");
    setJobId(uuid);
  }, [props]);

  useEffect(() => {}, [value]);

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      name: "",
      email: "",
      questions: [{ question: "current-status", answer: "" }],
      job: null,
      resume: null,
    },

    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      name: (value) => (value.length > 0 ? null : "Name is required"),
    },
  });

  return (
    <Box style={{ backgroundColor: "var(--oculera-surface-alt)" }}>
      <Navigation />
      <Container my={80} mb={"xl"}>
        <Box>
          <ReactMarkdown>{fileContent}</ReactMarkdown>
        </Box>
        {!jobNotFound &&
          (sent ? (
            <Group wrap="nowrap" p={"xl"} gap={"sm"}>
              <ThemeIcon radius="lg" size="lg">
                <IconCheck style={{ width: "70%", height: "70%" }} />
              </ThemeIcon>
              <Title p={"xl"} c={"blue"} order={3}>
                Application sent successfully
              </Title>
            </Group>
          ) : (
            <form
              onSubmit={form.onSubmit(async (values) => {
                setLoading(true);
                const formData = new FormData();
                formData.append("name", values.name);
                formData.append("email", values.email);
                formData.append("questions", JSON.stringify(values.questions));
                formData.append("resume", value);
                formData.append("job", jobId);

                const result = await applyJob(formData);
                if (result.status === 201) {
                  setSent(true);
                  setLoading(false);
                }
              })}
            >
              <Stack mx={"lg"}>
                <TextInput
                  label={"Name"}
                  placeholder={"Your name"}
                  {...form.getInputProps("name")}
                  withAsterisk
                />
                <TextInput
                  label={"Email"}
                  placeholder={"Your email"}
                  {...form.getInputProps("email")}
                  withAsterisk
                />
                <Textarea
                  label={
                    "Please explain why you are applying for this job and describe your current professional status."
                  }
                  autosize
                  minRows={3}
                  value={form.getValues().questions[0].answer}
                  onChange={(event) => {
                    form.replaceListItem("questions", 0, {
                      question: "current-status",
                      answer: event.target.value,
                    });
                  }}
                />

                <FileInput label={"Upload CV"} value={value} onChange={setValue} withAsterisk />
                <Group justify="flex-end" my="md">
                  <Button color={"orange"} type="submit" size="md" mb={"xl"}>
                    {loading ? <Loader size={"sm"} color={"white"} /> : "Apply"}
                  </Button>
                </Group>
              </Stack>
            </form>
          ))}
      </Container>
    </Box>
  );
}
